import WelcomeOrgScheduleOptions from '@/screens/WelcomeOrgScheduleOptions';

export default function PrivateWelcomeOrgScheduleOptionsRoute() {
  return <WelcomeOrgScheduleOptions />;
}
